export default __webpack_public_path__ + "static/media/thumbnail.daf4a868.jpeg";